import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';
import { CustomerspagesService } from './customerspages.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { CustomerRatingAndFeaturesComponent } from './customer-rating-and-features/customer-rating-and-features.component';
import { CustomersStoriesComponent } from './customers-stories/customers-stories.component';
import { CustomersCustomersComponent } from './customers-customers/customers-customers.component';
import { CustomersHeroComponent } from './customers-hero/customers-hero.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  imports: [
    CustomersHeroComponent,
    CustomersCustomersComponent,
    CustomersStoriesComponent,
    CustomerRatingAndFeaturesComponent,
    CommonGetstartedComponent,
    CommonCompaniesPanelComponent,
  ],
})
export class CustomersComponent implements OnInit {
  getStartedData: any;
  companiesData: any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private customersPagesService: CustomerspagesService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  ngOnInit(): void {
    this.customersPagesService.getCustomersData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Customer Stories';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.heroContentPanel?.fields?.image?.[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);
    let logos = data.customerStoriesClientsAndStats.fields?.components.map(
      (el:any) => el?.fields?.image?.fields?.file?.url
    );
    this.companiesData = logos;
    let started = data?.gettingStartedPanel?.fields;
    this.getStartedData = {
      header: started?.title,
      button1: {
        url: started?.buttons?.[0]?.fields?.redirectLink,
        text: started?.buttons?.[0]?.fields?.buttonText,
        target: started?.buttons?.[0]?.fields?.actionType,
      },
      button2: {
        url: started?.buttons?.[1]?.fields?.redirectLink,
        text: started?.buttons?.[1]?.fields?.buttonText,
        target: started?.buttons?.[1]?.fields?.actionType,
      },
    };
    this.posthogService.capturePageViewEvent('customer_stories');
  }
}
